var API_DOMAIN = "https://vinithapyroworld.zentexus.in/api";

export default API_DOMAIN;
